import { CommonUtility } from '@utility/common';
import { BaseService } from './base';
import { APIPath } from '../constants/api';
import { CRUDService } from './crud';

class ShippingLabelsCarriers extends CRUDService {
  constructor() {
    super(APIPath.shippingLabelCarriers);
  }

  updateShippingCredentials = (provider, data) => {
    const encoded = encodeURIComponent(provider);
    return BaseService.put(`${APIPath.shippingLabelCarriers}/${encoded}`, data);
  };

  updateDefaultShippingLabel = data =>
    BaseService.put(APIPath.shippingLabelSettings, data);

  removeProviderCarrierService = (id, params) =>
    BaseService.remove(
      `${APIPath.shippingLabelCarriers}/${id}/?${CommonUtility.objectToParams(
        params,
      )}`,
    );

  generateShippingLabelReport = data =>
    BaseService.post(APIPath.shippingLabelReport, data);
}

const ShippingLabelsCarriersService = new ShippingLabelsCarriers();
Object.freeze(ShippingLabelsCarriersService);
export default ShippingLabelsCarriersService;
